import { getUserLocation } from '../utilities/UserLocation';
import { requestLocationPermission } from '../utilities/requestLocationPermission';
import { Location } from './requestLocation.types';

const debug = require('debug')('tca:kit:utilities:requestLocation');

export const requestLocation = async (): Promise<Location | null> => {
  try {
    const permission = await requestLocationPermission();
    const granted = permission === 'granted';

    if (granted) {
      return await getUserLocation();
    }
  } catch (error) {
    debug(`Error getting location: ${JSON.stringify(error)}`);
  }

  return null;
};
